import FormSectionTitle from "../../components/styled/FormSectionTitle";
import MoneyReceiptSection from "./MoneyReceiptSection";

export default function CarField({ watch, control, errors, setValue, others, unregister }) {
  const { sl, isMulti } = others ?? {};

  const fields = [
    {
      label: "Name",
      name: isMulti ? `car.${sl}.name` : "car.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Chassis No.",
      name: isMulti ? `car.${sl}.chassis` : "car.chassis",
      type: "text",
      placeholder: "Chassis No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Engine No.",
      name: isMulti ? `car.${sl}.engine` : "car.engine",
      type: "text",
      placeholder: "Engine No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "BRTA Reg.",
      name: "car.brta_reg",
      type: "text",
      placeholder: "BRTA Reg.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Year/Model",
      name: isMulti ? `car.${sl}.year` : "car.year",
      type: "number",
      placeholder: "Year / Model",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Color",
      name: isMulti ? `car.${sl}.color` : "car.color",
      type: "text",
      placeholder: "Color",
      col: { md: 4, lg: 3 }
    },
    {
      label: "CC",
      name: isMulti ? `car.${sl}.cc` : "car.cc",
      type: "number",
      placeholder: "CC",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Fuel",
      name: isMulti ? `car.${sl}.fuel` : "car.fuel",
      type: "text",
      placeholder: "Fuel",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Descriptions",
      name: isMulti ? `car.${sl}.descriptions` : "car.descriptions",
      type: "textarea",
      placeholder: "Descriptions",
      col: { md: 12 }
    },
    {
      label: "Price",
      name: isMulti ? `car.${sl}.price` : "car.price",
      type: "number",
      placeholder: "Price",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Registration Cost",
      name: isMulti ? `car.${sl}.registration_cost` : "car.registration_cost",
      type: "number",
      placeholder: "Registration Cost",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Discount",
      name: isMulti ? `car.${sl}.discount` : "car.discount",
      type: "number",
      placeholder: "Discount",
      col: { md: 4, lg: 3 }
    }
  ];

  const isLoading = false;

  return (
    <MoneyReceiptSection
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}
      unregister={unregister}>
      <div className="col-12">
        <FormSectionTitle>{isMulti ? `${sl + 1}. ` : ""}Vehicle Information</FormSectionTitle>
      </div>
    </MoneyReceiptSection>
  );
}
